import { Configuration, PopupRequest,LogLevel  } from "@azure/msal-browser";
import { AD_appId, AD_tenantID } from "../config/config";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AD_appId||'',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AD_tenantID}`,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            // console.error(message);

            return;

          case LogLevel.Info:
            // console.info(message);

            return;

          case LogLevel.Verbose:
            // console.debug(message);

            return;

          case LogLevel.Warning:
            // console.warn(message);

            return;

          default:
            return;
        }
      },
    },

    allowNativeBroker: false,
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};